import React, { useState, useRef, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";

import "./security.scss";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Modal,
  Typography,
  TextField,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
// import Grid from '@mui/material/Grid';
import Grid from "@mui/material/Grid";
import qrbar from "../../Img/qr-bar.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";
import consts from "../../constant";
import usercalls from "../../Axios";
import { QRCodeSVG } from "qrcode.react";
import { UserDetails } from "../../Contexts/UserContext";
import Footernew from "../Footer/Footernew";

export default function Security() {
  const { userData } = useContext(UserDetails);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    userData?.f2A_Status == "false" && generate2FaCode();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const [load, setLoad] = useState(false);
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [googleauth, setgoogleauth] = useState(userData?.f2A_Status);

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [authCode, setAuthcode] = useState("");
  const [authOtp, setAuthOtp] = useState("");
  const handleCopyText = () => {
    navigator.clipboard.writeText(authCode).then(() => {
      return toast.success("Text Copied");
    });
  };
  useEffect(() => {
    setgoogleauth(userData?.f2A_Status);
  }, [userData]);
  // const showtoast = () => {
  //     setOpen(false);
  //     if (googleauth) {
  //         toast.success("enabled");
  //         setgoogleauth(false);
  //     }
  //     else {
  //         toast.error("disabled");
  //         setgoogleauth(true);
  //     }

  // }

  const data = [
    {
      id: 1,
      Datetime: "23-11-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 2,
      Datetime: "24-11-23",
      ipaddress: "192.40.234.43",
    },
    {
      id: 3,
      Datetime: "25-11-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 4,
      Datetime: "23-11-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 5,
      Datetime: "27-11-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 6,
      Datetime: "23-11-23",
      ipaddress: "W192.34.234.43",
    },
    {
      id: 7,
      Datetime: "13-10-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 8,
      Datetime: "23-09-23",
      ipaddress: "I192.34.234.43",
    },
    {
      id: 9,
      Datetime: "02-11-23",
      ipaddress: "192.34.234.43",
    },
    {
      id: 10,
      Datetime: "20-11-23",
      ipaddress: "192.34.234.43",
    },
  ];

  const filteredData = data.filter((row) => {
    const matchesSearch =
      row.Datetime.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.ipaddress.toLowerCase().includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const [oldPassword, setOldPassword] = useState();
  const [password, setPassword] = useState();

  const [confirmPassword, setConfirmPassword] = useState();
  const [confPassErr, setConfPassErr] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const path = usercalls();

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;

  const handleSubmit = async () => {
    if (!oldPassword) {
      toast.error("Old password is required");
      return;
    } else if (!passwordRegex.test(oldPassword)) {
      toast.error(
        "Old password must contain at least 8 characters, one uppercase letter, one number, and one special character (e.g., Abc@1234)"
      );
      return;
    }

    if (!password) {
      toast.error("New password is required");
      return;
    } else if (!passwordRegex.test(password)) {
      toast.error(
        "New password must contain at least 8 characters, one uppercase letter, one number, and one special character (e.g., Abc@1234)"
      );
      return;
    }

    if (!confirmPassword) {
      toast.error("Please confirm your new password");
      return;
    } else if (confirmPassword !== password) {
      toast.error("Passwords do not match");
      setConfPassErr("Passwords do not match");
      return;
    }

    const url = `${consts.BackendUrl}/users/UpdatePassword`;
    const payload = {
      oldPassword,
      NewPassword: password,
    };

    try {
      setLoad(true);
      setIsDisabled(true);
      const response = await path.postCall({ url, payload });
      const result = response.json({});
      result.then((data) => {
        if (data.success === true) {
          toast.success(data.message);
          handleClose1();
          setPassword("");
          setOldPassword("");
          setConfirmPassword("");
          setLoad(false);
        } else {
          toast.error(data.message);
          setLoad(false);
        }
      });
      setIsDisabled(false);
      setLoad(false);
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("An error occurred. Please try again later.");
      setLoad(false);
    }
  };

  const [authCodeUrl, setAuthcodeUrl] = useState("");

  const generate2FaCode = async () => {
    try {
      setLoad(true);
      const url = `${consts?.BackendUrl}/generate2fa`;
      const response = await path.postCall({ url });
      const result = await response.json();
      if (result?.success) {
        const authurl =
          result?.result?.otpauth_url + "&issuer=Dreamster-Exchange-Exchange";
        setAuthcode(result?.result?.secret);
        setAuthcodeUrl(authurl);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error generating 2Fa");
      setLoad(false);
    }
  };

  const verifyF2a = async () => {
    try {
      setLoad(true);
      const url = `${consts?.BackendUrl}/verify2fa`;
      const payload = { secret: authOtp };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setAuthOtp("");
        setOpen(false);
        setgoogleauth("true");
        setLoad(false);
      } else {
        toast.error(result?.message);
        setLoad(false);
      }
    } catch (error) {
      console.log(error, "error verifying 2Fa");
      setLoad(false);
    }
  };

  const disableF2a = async () => {
    try {
      setLoad(true);
      const url = `${consts?.BackendUrl}/disable2fa`;
      const payload = { secret: authOtp };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setAuthOtp("");
        setOpen(false);
        setgoogleauth("false");
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error disabling 2Fa");
      setLoad(false);
    }
  };

  return (
    <div className="menu-responsive">
      <div>
        <Header />
        {load && <Loader />}
        <ToastContainer />
        <div className="main_flx">
          <Sidebar />

          <div style={{ width: "100%" }}>
            <div className="abvbar split_half">
              <h6>Security</h6>
            </div>
            <div className="split_half">
              <div className="security box_bdr">
                {/* <h4>Authentication</h4> */}

                <div className="flx">
                  <div>
                    <svg
                      width="17"
                      height="20"
                      viewBox="0 0 17 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.7832 8.76196C4.31836 8.13227 4.0625 7.36743 4.0625 6.56235C4.0625 4.21594 6.23101 2.44102 8.54336 2.93188C8.63789 2.06665 8.97305 1.2725 9.48047 0.618598C4.60965 -0.478785 0 3.24969 0 8.20297C0 9.56821 0.355859 10.8998 1.03047 12.0721C1.87969 10.5967 3.19922 9.42446 4.7832 8.76196Z"
                        fill="#1E2329"
                      />
                      <path
                        d="M8.57109 4.15216C6.93836 3.60786 5.23438 4.83193 5.23438 6.56271C5.23438 7.2506 5.50703 7.89552 5.99102 8.37091C7.15879 8.09528 8.38801 8.09528 9.55586 8.37091C9.92305 8.00997 10.1687 7.55138 10.266 7.0506C9.37734 6.3463 8.75352 5.3213 8.57109 4.15216Z"
                        fill="#1E2329"
                      />
                      <path
                        d="M2.09229 12.5781H13.4548C12.3036 10.6387 10.188 9.33594 7.77354 9.33594C5.35908 9.33594 3.24346 10.6387 2.09229 12.5781Z"
                        fill="#1E2329"
                      />
                      <path
                        d="M11.3148 7.67656C11.193 8.06641 11.007 8.4332 10.7637 8.7625C12.3477 9.425 13.6672 10.5973 14.5164 12.0727C15.3314 10.6558 15.6764 9.0125 15.5039 7.38477C14.1988 8.17418 12.6304 8.24141 11.3148 7.67656Z"
                        fill="#1E2329"
                      />
                      <path
                        d="M13.125 0C11.2266 0 9.6875 1.53906 9.6875 3.4375C9.6875 5.33594 11.2266 6.875 13.125 6.875C15.0234 6.875 16.5625 5.33594 16.5625 3.4375C16.5625 1.53906 15.0234 0 13.125 0ZM14.7895 3.26602L13.5395 4.51602C13.312 4.74355 12.9403 4.74578 12.7105 4.51602L12.0855 3.89102C11.857 3.66211 11.857 3.29102 12.0855 3.06211C12.3145 2.83359 12.6855 2.83359 12.9145 3.06211L13.125 3.27305L13.9605 2.43711C14.1895 2.20859 14.5605 2.20859 14.7895 2.43711C15.018 2.66602 15.018 3.03711 14.7895 3.26602Z"
                        fill="#1E2329"
                      />
                      <path
                        d="M14.1094 13.5H1.45312C0.805898 13.5 0.28125 14.0247 0.28125 14.6719V18.5781C0.28125 19.2253 0.805898 19.75 1.45312 19.75H14.1094C14.7566 19.75 15.2812 19.2253 15.2812 18.5781V14.6719C15.2812 14.0247 14.7566 13.5 14.1094 13.5ZM2.78125 17.1721C2.45766 17.1721 2.19512 16.9095 2.19512 16.5859C2.19512 16.2623 2.45766 15.9998 2.78125 15.9998C3.10484 15.9998 3.36738 16.2623 3.36738 16.5859C3.36738 16.9095 3.10484 17.1721 2.78125 17.1721ZM5.28125 17.1721C4.95766 17.1721 4.69512 16.9095 4.69512 16.5859C4.69512 16.2623 4.95766 15.9998 5.28125 15.9998C5.60484 15.9998 5.86738 16.2623 5.86738 16.5859C5.86738 16.9095 5.60484 17.1721 5.28125 17.1721ZM7.78125 17.1721C7.45766 17.1721 7.19512 16.9095 7.19512 16.5859C7.19512 16.2623 7.45766 15.9998 7.78125 15.9998C8.10484 15.9998 8.36738 16.2623 8.36738 16.5859C8.36738 16.9095 8.10484 17.1721 7.78125 17.1721ZM10.2812 17.1721C9.95766 17.1721 9.69512 16.9095 9.69512 16.5859C9.69512 16.2623 9.95766 15.9998 10.2812 15.9998C10.6048 15.9998 10.8674 16.2623 10.8674 16.5859C10.8674 16.9095 10.6048 17.1721 10.2812 17.1721ZM12.7812 17.1721C12.4577 17.1721 12.1951 16.9095 12.1951 16.5859C12.1951 16.2623 12.4577 15.9998 12.7812 15.9998C13.1048 15.9998 13.3674 16.2623 13.3674 16.5859C13.3674 16.9095 13.1048 17.1721 12.7812 17.1721Z"
                        fill="#1E2329"
                      />
                    </svg>
                  </div>
                  <div>
                    <div>
                      <h5>Google Authenticator</h5>
                      <p>
                        Verify using time-based OTPs generated via Google
                        Authenticator App (recommended){" "}
                        <div className="d_gry"> Change/lost device?</div>
                        {/* <Link to={"/support"} className="contact">
                          {" "}
                          contact support
                        </Link> */}
                      </p>
                    </div>
                    <div className="right">
                      {/* <div className='d-flx' >
                                        <img src={tic} alt="img" />
                                        <div>On</div>
                                    </div> */}
                      <Link to={"#"} className="grey_btn" onClick={handleOpen}>
                        {" "}
                        {googleauth === "false" ? "Enable" : "Disable"}{" "}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="flx">
                  <div>
                    <svg
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.16992 3.08268C8.16992 3.4657 8.09448 3.84498 7.9479 4.19884C7.80133 4.55271 7.58649 4.87424 7.31565 5.14508C7.04481 5.41591 6.72328 5.63075 6.36942 5.77733C6.01555 5.92391 5.63628 5.99935 5.25326 5.99935C4.87023 5.99935 4.49096 5.92391 4.13709 5.77733C3.78323 5.63075 3.4617 5.41591 3.19086 5.14508C2.92002 4.87424 2.70518 4.55271 2.55861 4.19884C2.41203 3.84498 2.33659 3.4657 2.33659 3.08268C2.33659 2.30913 2.64388 1.56727 3.19086 1.02029C3.73784 0.473307 4.47971 0.166016 5.25326 0.166016C6.0268 0.166016 6.76867 0.473307 7.31565 1.02029C7.86263 1.56727 8.16992 2.30913 8.16992 3.08268ZM12.3366 4.12435C12.6129 4.12435 12.8778 4.2341 13.0732 4.42945C13.2685 4.6248 13.3783 4.88975 13.3783 5.16602C13.3783 5.44228 13.2685 5.70723 13.0732 5.90259C12.8778 6.09794 12.6129 6.20768 12.3366 6.20768C12.0603 6.20768 11.7954 6.09794 11.6 5.90259C11.4047 5.70723 11.2949 5.44228 11.2949 5.16602C11.2949 4.88975 11.4047 4.6248 11.6 4.42945C11.7954 4.2341 12.0603 4.12435 12.3366 4.12435ZM12.3366 2.04102C13.074 2.04076 13.7877 2.30125 14.3515 2.77642C14.9154 3.2516 15.293 3.91085 15.4177 4.6376C15.5424 5.36436 15.4061 6.11179 15.0328 6.74773C14.6596 7.38367 14.0735 7.86715 13.3783 8.11268V9.33268H14.6666V11.8327H13.3783V13.0827H11.2949V8.11268C10.6016 7.86543 10.0177 7.38149 9.64611 6.74606C9.27452 6.11064 9.13902 5.36448 9.26349 4.63898C9.38796 3.91347 9.76441 3.25515 10.3266 2.77992C10.8887 2.30469 11.6005 2.04303 12.3366 2.04102ZM3.16992 7.66602C2.50688 7.66602 1.871 7.92941 1.40215 8.39825C0.933314 8.86709 0.669922 9.50297 0.669922 10.166V12.666H9.83659V10.166C9.83659 9.50297 9.5732 8.86709 9.10436 8.39825C8.63551 7.92941 7.99963 7.66602 7.33659 7.66602H3.16992Z"
                        fill="#1E2329"
                      />
                    </svg>
                  </div>
                  <div>
                    <div>
                      <h5>Password</h5>
                      <p>
                        Change your password regularly to prevent unauthorized
                        access
                      </p>
                    </div>
                    <div className="right">
                      {/* <div className='d-flx' >
                                        <img src={tic} alt="img" />
                                        <div>On</div>
                                    </div> */}
                      <Link to={"#"} className="grey_btn" onClick={handleOpen1}>
                        Change{" "}
                      </Link>
                    </div>
                  </div>
                </div>

                {/* <div className="flx">
                            <div>
                              <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.833496 0H19.1668V10H0.833496V0ZM17.5002 1.66667H15.8335V8.33333H17.5002V1.66667ZM5.41683 5C5.41683 4.55797 5.24123 4.13405 4.92867 3.82149C4.61611 3.50893 4.19219 3.33333 3.75016 3.33333C3.30814 3.33333 2.88421 3.50893 2.57165 3.82149C2.25909 4.13405 2.0835 4.55797 2.0835 5C2.0835 5.44203 2.25909 5.86595 2.57165 6.17851C2.88421 6.49107 3.30814 6.66667 3.75016 6.66667C4.19219 6.66667 4.61611 6.49107 4.92867 6.17851C5.24123 5.86595 5.41683 5.44203 5.41683 5ZM10.0002 5C10.0002 4.55797 9.82457 4.13405 9.51201 3.82149C9.19945 3.50893 8.77552 3.33333 8.3335 3.33333C7.89147 3.33333 7.46755 3.50893 7.15498 3.82149C6.84242 4.13405 6.66683 4.55797 6.66683 5C6.66683 5.44203 6.84242 5.86595 7.15498 6.17851C7.46755 6.49107 7.89147 6.66667 8.3335 6.66667C8.77552 6.66667 9.19945 6.49107 9.51201 6.17851C9.82457 5.86595 10.0002 5.44203 10.0002 5ZM14.5835 5C14.5835 4.55797 14.4079 4.13405 14.0953 3.82149C13.7828 3.50893 13.3589 3.33333 12.9168 3.33333C12.4748 3.33333 12.0509 3.50893 11.7383 3.82149C11.4258 4.13405 11.2502 4.55797 11.2502 5C11.2502 5.44203 11.4258 5.86595 11.7383 6.17851C12.0509 6.49107 12.4748 6.66667 12.9168 6.66667C13.3589 6.66667 13.7828 6.49107 14.0953 6.17851C14.4079 5.86595 14.5835 5.44203 14.5835 5Z" fill="#1E2329" /></svg>
                            </div>
                            <div>
                                <div>
                                    <h5>Login Password</h5>
                                    <p>Login password is used to log in to your account.</p>
                                </div>
                                <div className='right' > 
                                    <Link to={"#"} className='grey_btn' >Manage  </Link>
                                </div>
                            </div>
                            
                        </div> */}
                <div className="flx">
                  <div>
                    <svg
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.16992 3.08268C8.16992 3.4657 8.09448 3.84498 7.9479 4.19884C7.80133 4.55271 7.58649 4.87424 7.31565 5.14508C7.04481 5.41591 6.72328 5.63075 6.36942 5.77733C6.01555 5.92391 5.63628 5.99935 5.25326 5.99935C4.87023 5.99935 4.49096 5.92391 4.13709 5.77733C3.78323 5.63075 3.4617 5.41591 3.19086 5.14508C2.92002 4.87424 2.70518 4.55271 2.55861 4.19884C2.41203 3.84498 2.33659 3.4657 2.33659 3.08268C2.33659 2.30913 2.64388 1.56727 3.19086 1.02029C3.73784 0.473307 4.47971 0.166016 5.25326 0.166016C6.0268 0.166016 6.76867 0.473307 7.31565 1.02029C7.86263 1.56727 8.16992 2.30913 8.16992 3.08268ZM12.3366 4.12435C12.6129 4.12435 12.8778 4.2341 13.0732 4.42945C13.2685 4.6248 13.3783 4.88975 13.3783 5.16602C13.3783 5.44228 13.2685 5.70723 13.0732 5.90259C12.8778 6.09794 12.6129 6.20768 12.3366 6.20768C12.0603 6.20768 11.7954 6.09794 11.6 5.90259C11.4047 5.70723 11.2949 5.44228 11.2949 5.16602C11.2949 4.88975 11.4047 4.6248 11.6 4.42945C11.7954 4.2341 12.0603 4.12435 12.3366 4.12435ZM12.3366 2.04102C13.074 2.04076 13.7877 2.30125 14.3515 2.77642C14.9154 3.2516 15.293 3.91085 15.4177 4.6376C15.5424 5.36436 15.4061 6.11179 15.0328 6.74773C14.6596 7.38367 14.0735 7.86715 13.3783 8.11268V9.33268H14.6666V11.8327H13.3783V13.0827H11.2949V8.11268C10.6016 7.86543 10.0177 7.38149 9.64611 6.74606C9.27452 6.11064 9.13902 5.36448 9.26349 4.63898C9.38796 3.91347 9.76441 3.25515 10.3266 2.77992C10.8887 2.30469 11.6005 2.04303 12.3366 2.04102ZM3.16992 7.66602C2.50688 7.66602 1.871 7.92941 1.40215 8.39825C0.933314 8.86709 0.669922 9.50297 0.669922 10.166V12.666H9.83659V10.166C9.83659 9.50297 9.5732 8.86709 9.10436 8.39825C8.63551 7.92941 7.99963 7.66602 7.33659 7.66602H3.16992Z"
                        fill="#202630"
                      />
                    </svg>
                  </div>
                  <div>
                    <div>
                      <h5>KYC</h5>
                      <p>
                        Complete your KYC verification to unlock all the
                        features of your Dreamster-Exchange account.
                      </p>
                    </div>
                    <div className="right">
                      {/* <div className='d-flx' >
                                        <img src={tic} alt="img" />
                                        <div>On</div>
                                    </div> */}
                      <Link to={"/Kycverify"} className="grey_btn">
                        Verify{" "}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* google auth  */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            class="boxstyle"
            style={{ borderRadius: "10px;", boxShadow: "none" }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="otp_flx">
                <span
                  className="otp"
                  style={{
                    paddingLeft: "45px",
                    paddingRight: "45px",
                    width: "100%",
                    textAlign: "center",
                    // borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
                    paddingBottom: "5px",
                  }}
                >
                  Google Authentication{" "}
                </span>
                <svg
                  style={{ position: "absolute", right: "35px" }}
                  onClick={handleClose}
                  className="cursor-pointer fill_dark_to_white"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.75 2.25L2.25 15.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.75 15.75L2.25 2.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </Typography>
            <br />
            {googleauth == "false" && (
              <>
                <p>
                  Install google autheticator app and scan QR Code (or) If you
                  are unable to scan the QR code, please enter this code
                  manually.
                </p>

                <div className="input_box mb-20 mt-10">
                  <TextField
                    type="text"
                    fullWidth
                    value={authCode}
                    sx={{
                      "& .MuiInputBase-formControl": {
                        borderRadius: "5px",
                        backgroundColor: "transparent",
                      },
                      "& .MuiInputBase-input": {
                        padding: "11px 20px",
                        border: "0",
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "left",
                      },
                      "& fieldset": { border: "1px solid #818898 !important" },
                      "& .MuiInputBase-input::placeholder": {
                        color: "black",
                        fontSize: "15px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" className="cursor">
                          <div
                            style={{ color: "#818898" }}
                            onClick={() => handleCopyText()}
                          >
                            Copy
                          </div>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </>
            )}
            <label className="grey_label">Enter your code</label>
            <div className="input_box mb-20 mt-10">
              <TextField
                type="text"
                fullWidth
                placeholder="Enter Your code"
                value={authOtp}
                onChange={(e) => setAuthOtp(e.target.value)}
                sx={{
                  "& .MuiInputBase-formControl": {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                  },
                  "& .MuiInputBase-input": {
                    padding: "11px 20px",
                    border: "0",
                    fontSize: "16px",
                    fontWeight: "400",
                    textAlign: "left",
                  },
                  "& fieldset": { border: "1px solid #818898 !important" },
                  "& .MuiInputBase-input::placeholder": {
                    color: "black",
                    fontSize: "15px",
                  },
                }}
              />
            </div>

            {googleauth == "false" && (
              <div
                style={{ width: "150px", margin: "auto", marginBottom: "15px" }}
              >
                {/* <img src={qrbar} alt="qr-bar" /> */}
                <div className="qr-code">
                  <QRCodeSVG value={authCodeUrl} />
                </div>
              </div>
            )}

            <Link
              to={"#"}
              onClick={googleauth === "true" ? disableF2a : verifyF2a}
              className="org_btn sm_txt"
              style={{
                padding: "12px 60px",
                marginBottom: "10px",
                display: "block",
                fontWeight: "700",
                margin: "0 auto",
                width: "75%",
                textAlign: "center",
              }}
            >
              SUBMIT
            </Link>
          </Box>
        </Modal>

        {/* password */}
        <Modal
          open={open1}
          onClose={handleClose1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            class="boxstyle"
            style={{ borderRadius: "10px;", boxShadow: "none" }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="otp_flx">
                <span
                  className="otp"
                  style={{
                    paddingLeft: "45px",
                    paddingRight: "45px",
                    width: "100%",
                    textAlign: "center",
                    // borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
                    paddingBottom: "5px",
                  }}
                >
                  Password{" "}
                </span>
                <svg
                  style={{ position: "absolute", right: "35px" }}
                  onClick={handleClose1}
                  className="cursor-pointer fill_dark_to_white"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.75 2.25L2.25 15.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.75 15.75L2.25 2.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </Typography>
            <br />
            <label className="grey_label">Enter old password</label>
            <div className="input_box mb-20 mt-10">
              <TextField
                type="text"
                fullWidth
                placeholder="Enter old password"
                sx={{
                  "& .MuiInputBase-formControl": {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                  },
                  "& .MuiInputBase-input": {
                    padding: "11px 20px",
                    border: "0",
                    fontSize: "16px",
                    fontWeight: "400",
                    textAlign: "left",
                  },
                  "& fieldset": { border: "1px solid #818898 !important" },
                  "& .MuiInputBase-input::placeholder": {
                    color: "black",
                    fontSize: "15px",
                  },
                }}
                value={oldPassword}
                onChange={(e) => {
                  setOldPassword(e.target.value);
                }}
              />
            </div>

            <label className="grey_label">Enter New password</label>
            <div className="input_box mb-20 mt-10">
              <TextField
                type="text"
                fullWidth
                placeholder="Enter New password"
                sx={{
                  "& .MuiInputBase-formControl": {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                  },
                  "& .MuiInputBase-input": {
                    padding: "11px 20px",
                    border: "0",
                    fontSize: "16px",
                    fontWeight: "400",
                    textAlign: "left",
                  },
                  "& fieldset": { border: "1px solid #818898 !important" },
                  "& .MuiInputBase-input::placeholder": {
                    color: "black",
                    fontSize: "15px",
                  },
                }}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>

            <label className="grey_label">Re-Enter New password</label>
            <div className="input_box mb-20 mt-10">
              <TextField
                type="text"
                fullWidth
                placeholder="Re-Enter New password"
                sx={{
                  "& .MuiInputBase-formControl": {
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                  },
                  "& .MuiInputBase-input": {
                    padding: "11px 20px",
                    border: "0",
                    fontSize: "16px",
                    fontWeight: "400",
                    textAlign: "left",
                  },
                  "& fieldset": { border: "1px solid #818898 !important" },
                  "& .MuiInputBase-input::placeholder": {
                    color: "black",
                    fontSize: "15px",
                  },
                }}
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
              />
            </div>

            <Link
              to={"#"}
              className={`org_btn sm_txt ${isDisabled ? "disabled" : ""}`}
              style={{
                padding: "12px 60px",
                marginBottom: "10px",
                display: "block",
                fontWeight: "700",
                margin: "0 auto",
                width: "75%",
                textAlign: "center",
                pointerEvents: isDisabled ? "none" : "auto",
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              onClick={!isDisabled ? handleSubmit : undefined}
            >
              SUBMIT
            </Link>
          </Box>
        </Modal>

        {/* Account Activity */}
        <Modal
          open={open2}
          onClose={handleClose2}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            class="boxstyle"
            style={{ borderRadius: "20px;", boxShadow: "none" }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="otp_flx">
                <span
                  className="otp"
                  style={{
                    paddingLeft: "45px",
                    paddingRight: "45px",
                    width: "100%",
                    textAlign: "center",
                    // borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
                    paddingBottom: "5px",
                  }}
                >
                  {" "}
                  Account Activity{" "}
                </span>
                <svg
                  style={{ position: "absolute", right: "35px" }}
                  onClick={handleClose2}
                  className="cursor-pointer fill_dark_to_white"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.75 2.25L2.25 15.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.75 15.75L2.25 2.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </Typography>
            <br />
            <div className="input_box">
              <TextField
                fullWidth
                placeholder="Search"
                sx={{
                  borderRadius: "50px",
                  "& .MuiInputBase-formControl": { borderRadius: "5px" },
                  "& .MuiInputBase-input": {
                    padding: "11px 5px 11px 15px",
                    border: "0",
                  },
                  "& fieldset": { border: "1px solid #d3d1d1 !important" },
                  "& .MuiInputBase-input::placeholder": {
                    color: "black",
                    fontSize: "15px",
                  },
                }}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <svg
                        className=""
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_55_24278)">
                          <path
                            d="M16.6 18.3984L10.3 12.0984C9.8 12.4984 9.225 12.8151 8.575 13.0484C7.925 13.2817 7.23333 13.3984 6.5 13.3984C4.68333 13.3984 3.14583 12.7692 1.8875 11.5109C0.629167 10.2526 0 8.7151 0 6.89843C0 5.08177 0.629167 3.54427 1.8875 2.28593C3.14583 1.0276 4.68333 0.398438 6.5 0.398438C8.31667 0.398438 9.85417 1.0276 11.1125 2.28593C12.3708 3.54427 13 5.08177 13 6.89843C13 7.63177 12.8833 8.32343 12.65 8.97343C12.4167 9.62343 12.1 10.1984 11.7 10.6984L18 16.9984L16.6 18.3984ZM6.5 11.3984C7.75 11.3984 8.8125 10.9609 9.6875 10.0859C10.5625 9.21093 11 8.14843 11 6.89843C11 5.64843 10.5625 4.58593 9.6875 3.71093C8.8125 2.83593 7.75 2.39843 6.5 2.39843C5.25 2.39843 4.1875 2.83593 3.3125 3.71093C2.4375 4.58593 2 5.64843 2 6.89843C2 8.14843 2.4375 9.21093 3.3125 10.0859C4.1875 10.9609 5.25 11.3984 6.5 11.3984Z"
                            fill="#1E2329"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_55_24278">
                            <rect width="18" height="19" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="custom_table">
              <TableContainer sx={{ marginBottom: "10px" }}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Date/time</TableCell>
                      <TableCell>Ip Address</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((row) => (
                      <TableRow key={row.id} className="tr_row">
                        <TableCell width={"24px"}>{row.id}</TableCell>
                        <TableCell width={"150px"}>{row.Datetime}</TableCell>
                        <TableCell>{row.ipaddress}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15]} // Options for rows per page
                  component="div"
                  count={filteredData.length} // Total number of filtered rows
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </Box>
        </Modal>
      </div>
      <Footernew />
    </div>
  );
}
